<template>
  <div class="tools">
    <div class="tools__demo">
      <h1 class="tools__demo--h1">درباره ما</h1>
    </div>
    <div class="tools__filters"></div>
    <div class="tools__items">
      <div class="tools__items--container">
        <p v-html="sentences"></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      sentences: "",
    };
  },
  methods: {},
  created() {
    var that = this;
    that.$store.state.load = true;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    $.ajax({
      url: that.$store.state.url + "api/v1/pages/extra_page/aboutus/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data, "ddddddddd");
        that.sentences = data;
      },
      error: function (request, textStatus, errorThrown) {
        if (request.state == 500) {
          that.$toastr.e("خطایی در سرور به وجود امده");
          that.$store.state.e500 = true;
        } else {
          that.$store.state.e404 = true;
          that.$toastr.e("خطا در برقراری ارتباط");
        }
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
  },
};
</script>
<style lang="scss" scoped>
// @import "~pretty-checkbox/src/pretty-checkbox.scss";

.tools {
  width: 100%;
  min-height: auto;
  // background: red;
  margin-top: 8em;
  display: flex;
  flex-wrap: wrap;
  // flex-direction: row-reverse;
  @media screen and (max-width: 500px) {
  }
  &__demo {
    width: 100%;
    // background: var(--sub-color);
    background-image: linear-gradient(to right top, #f04d58d8, #f04d58),
      url("../../assets/photo/11.jpg");
    background-attachment: fixed;
    background-position: center center;
    background-size: cover;
    z-index: -1;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -0.5em;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.24);
    &--h1 {
      color: var(--sub-color);
      background: var(--main-color);
      padding: 0.25em 1em;
      border-radius: 10px;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.24);
      @media screen and (max-width: 800px) {
        // width: 100%;
        font-size: 1.7em;
      }
      @media screen and (max-width: 400px) {
        // width: 100%;
        font-size: 1.5em;
      }
      // font-family: "lalezar";
    }
    // position: absolute;
  }
  &__items {
    // text-align: ;
    // display: flex;
    direction: rtl;
    // flex-direction: column;
    width: 100%;
    // background: red;
    // margin-right: 0.5em;
    // margin-left: auto;
    // align-items: center;

    &--adress {
      margin-right: 0.6em;
      margin: 1em;
      align-self: flex-start;
      font-size: 0.8em;
    }
    &--container {
      width: 98%;
      height: auto;
      background: var(--main-color);
      border: 1px solid #ebe9e9;
      position: relative;
      margin-right: auto;
      margin-left: auto;
      // padding: 0 44px 0 130px;
      z-index: 2;
      // box-shadow: 0 0 5px rgba(0, 0, 0, 0.308);
      overflow: hidden;
      margin-top: 2em;
      padding: 2em;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      p {
        width: 100%;
        margin-top: 3em;
        margin-bottom: 3em;
      }
      &--nav {
        display: flex;
        width: 100%;
        // height: 50px;
        // z-index: 90;
        background: var(--main-color);
        border-bottom: 1px solid #ebe9e9;
        &-ul {
          display: flex;
          font-size: 0.9em;
          margin: 0.7em;
          align-items: center;
          @media screen and (max-width: 500px) {
            // width: 100%;
            font-size: 0.65em;
          }
          @media screen and (max-width: 400px) {
            // width: 100%;
            font-size: 0.5em;
          }

          svg {
            margin-left: 0.3em;
          }
          a {
            text-decoration: none;
          }
          &-li {
            color: var(--font-color);
            font-size: 0.85em;
            margin: 0 0.2em;
            border-radius: 10px;
            padding: 0.2em 0.8em;
          }
        }
      }
    }
  }
}
.act {
  background: var(--shrink);
  color: var(--main-color);
}
// Switcher - Bootstrap's Check Button
// Still improving...
// $background: #233d4d;
// var(--shrink): #d3d3be;
.chkbx input[type="checkbox"] {
  display: none;
}

.chkbx {
  position: relative;
  cursor: pointer;
  .x {
    display: block;
    width: 55px;
    height: 26px;
    border: 1px solid var(--shrink);
    border-radius: 60px;
    transition: 0.5s;
    background: var(--main-color);
    &:before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      top: 3px;
      left: 5px;
      box-sizing: border-box;
      background: var(--bg-color);
      border: 1px solid var(--font-color);
      border-radius: 40px;
      transition: 0.5s;
    }
  }
  :checked ~ .x:before {
    background: var(--main-color);
    border-color: var(--main-color);
    transform: translatex(25px);
  }
  :checked ~ .x {
    background: var(--shrink);
    border-color: var(--shrink);
  }
}
.checke--color {
  width: 15px;
  height: 12px;
  margin-left: 1em;
  border-radius: 50%;
  border: 1px solid var(--font-color);
}
// /////////////////////////////////////////////////////////////////////////
.checkbox {
  direction: rtl;
  display: flex;
  // justify-content: center;
  align-items: center;
  position: relative;
  padding-left: 35px;
  margin-bottom: 20px;
  cursor: pointer;
  margin-top: 0.8em;
  // font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  // background: red;
  width: 100%;
}

/* Hide the browser's default checkbox */
.checkbox input {
  direction: rtl;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-100%, 30%);
  border-radius: 2px;
  height: 15px;
  width: 15px;
  background-color: var(--main-color);
  border: 1px solid #ccc;
  direction: rtl;
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkmark {
  background-color: var(--bg-color);
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkmark {
  background-color: var(--shrink);
  border: none;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkmark:after {
  left: 5px;
  top: 3px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.ttt {
  margin-right: 3em;
  // margin-top: 1em;
  font-size: 0.9em;
}
.pagination {
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  // background: red;
  // padding: 1.5em 20em;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-top: 1em;
    margin-bottom: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue